import React, { useContext, useEffect, useState } from 'react';
import { ArrowRightSquare, Check2Circle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardBody,
  ListGroupItem,
  ListGroup,
  Container,
  Row,
  Col,
  Media
} from 'reactstrap';

import CardsHeader from '../../components/Headers/CardsHeader';
import { Store } from '../../Store';
import client from '../../utils/client';
import { getPlusUrl, getTokenData } from '../../utils/helpers';

let plusUrl;
function Dashboard() {
  const { state, dispatch } = useContext(Store);
  const { data: notifications } = state.notifications;
  const { data: dashboard } = state.dashboard;

  const { t } = useTranslation();

  const [golfclub, setGolfclub] = useState(null);
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    plusUrl = getPlusUrl();
    const tokenData = getTokenData();
    setGolfclub(tokenData?.name);
  }, []);

  useEffect(() => {
    (async () => {
      const { data: dshData } = await client('admin-gc/dashboard');
      if (dshData) {
        dispatch({ type: 'DASHBOARD_FETCHED', payload: dshData });
      }

      const { data: cmp } = await client('admin-gc/campaigns');
      if (cmp) {
        setCampaign(cmp);
      }
    })();
  }, []);

  return (
    <>
      <CardsHeader
        // name={`${t('dashboard.title', 'Välkommen')} ${golfclub}`}
        name={`${golfclub} - ${t('default.brand')} Online Admin Tool`}
        dashboardData={dashboard}
      />
      <Container className="mt--6" fluid>
        {campaign && (
          <Row>
            <Col>
              <Card>
                <Link to="/golfclub-admin/sales">
                  <CardHeader className="bg-default">
                    <Row className="align-items-center">
                      <Col>
                        <h6 className="text-uppercase ls-1 mb-1">
                          {t('default.ongoing-campaign')}
                        </h6>
                        <h5 className="h3 text-white mb-0">
                          {campaign.name}{' '}
                          <small>
                            ({campaign.validFrom} - {campaign.validTo})
                          </small>
                        </h5>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <p
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: campaign.shortDescription }}
                      style={{ color: '#000' }}
                    />
                    <ArrowRightSquare size={30} className="float-right mb-3" />
                  </CardBody>
                </Link>
              </Card>
            </Col>
          </Row>
        )}
        <Row>
          <Col xl="4">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col>
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      {t('dashboard.latest-comment', 'Senaste kommentar')}
                    </h6>
                    <h5 className="h3 mb-0">
                      {t('dashboard.latest-comment-from', 'från era kunder')}
                    </h5>
                  </Col>
                  <Link to="/golfclub-admin/statistic/comments" style={{ color: '#525f7f' }}>
                    <ArrowRightSquare size={30} className="float-right" />
                  </Link>
                </Row>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Media className="media-comment">
                    <div className="icon icon-shape bg-gradient-green text-white media-comment-avatar">
                      <i className="ni ni-chat-round" />
                    </div>

                    <Media>
                      <div className="media-comment-text">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="text-right text-muted">
                            <small>{dashboard?.comment?.date}</small>
                          </div>
                        </div>
                        <p
                          className="text-sm lh-160"
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: dashboard?.comment?.comment.substring(0, 200)
                          }}
                        />
                      </div>
                    </Media>
                  </Media>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col>
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      {t('dashboard.latest-news', 'Senaste nytt')}
                    </h6>
                    <h5 className="h3 mb-0">{t('dashboard.latest-news-from', 'från Golfamore')}</h5>
                  </Col>
                  <Link to="/golfclub-admin/notifications" style={{ color: '#525f7f' }}>
                    <ArrowRightSquare size={30} className="float-right" />
                  </Link>
                </Row>
              </CardHeader>
              <CardBody className="p-0">
                <ListGroup flush>
                  {notifications?.map((n) => (
                    <ListGroupItem className="flex-column align-items-start py-4 px-4" key={n.id}>
                      <div className="checklist-item">
                        <div>
                          <h5 className="checklist-title mb-0">{n.title}</h5>
                          <small>{n.date}</small>
                        </div>
                        {n.read && <Check2Circle style={{ color: '#2dce89' }} size={20} />}
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </CardBody>
            </Card>
          </Col>

          <Col xl="4">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col>
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      {t('dashboard.upcoming', 'Kommande')}
                    </h6>
                    <h5 className="h3 mb-0">{t('dashboard.upcoming-plus', 'PLUS tider')}</h5>
                  </Col>
                  <a href={plusUrl} target="_blank" rel="noreferrer" style={{ color: '#525f7f' }}>
                    <ArrowRightSquare size={30} className="float-right" />
                  </a>
                </Row>
              </CardHeader>

              <CardBody className="p-0">
                <ListGroup flush>
                  {dashboard?.plusTimes?.map((p) => (
                    <ListGroupItem
                      className="flex-column align-items-start py-4 px-4"
                      key={p.startDate}
                    >
                      <div className="checklist-item">
                        <div>
                          <h5 className="checklist-title mb-0">
                            {p.startDate} - {p.endDate}
                          </h5>
                          <small>
                            {p.times.map((ti) => (
                              <span className="mr-2" key={ti}>
                                {ti}
                              </span>
                            ))}
                          </small>
                        </div>
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* <Row>
          <Col xl="4">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col>
                    <h5 className="h3 mb-0">Kontaktpersoner</h5>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="p-0">
                <ListGroup flush>
                  {dashboard?.contactPersons?.map((c) => (
                    <ListGroupItem className="flex-column align-items-start py-4 px-4" key={c.id}>
                      <h5 className="checklist-title mb-0">{c.name}</h5>
                      <Row className="align-items-center">
                        <Col>
                          <span className="text-default">●</span> <small>{c.title}</small>
                          <br />
                          <small>{c.email}</small>
                          <br />
                          <small>{c.mobile}</small>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                  <ListGroupItem />
                </ListGroup>
                <Row>
                  <Col>
                    <Button color="danger" size="sm" className="float-right m-3 ">
                      Uppgifterna är felaktiga
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
      </Container>
    </>
  );
}

export default Dashboard;
